import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import {
    getPageLinkByNodeId,
    LinkModel,
    useGetLink,
    useGetLinks,
} from "@insite/client-framework/Store/Links/LinksSelectors";
import { HasFields } from "@insite/client-framework/Types/ContentItemModel";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { useMergeStyles } from "@insite/content-library/additionalStyles";
import Img from "@insite/mobius/Img";
import Link from "@insite/mobius/Link";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as cssLinter from "css";
import * as React from "react";
import { FC } from "react";
import { css } from "styled-components";

const enum fields {
    direction = "direction",
    alignment = "alignment",
    title = "title",
    titleLink = "titleLink",
    links = "links",
    customCSS = "customCSS",
    image = "image",
    destination = "destination",
    slides = "slides",
    innerSlides = "innerSlides",
    internalListLinks = "internalListLinks",
    internalImage = "internalImage",
}

interface InternalListModel {
    fields: InternalListArray;
}

interface InternalListArray {
    internalImage: string;
    destination: any;
}

interface SlideModel {
    fields: {
        Title: string;
        Image: string;
        // destination: string;
        destination: any;
        internalListLinks: InternalListModel[];
    };
}

interface testModel {
    fields: {
        innerImage: string;
    };
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.direction]: "vertical" | "horizontal";
        [fields.alignment]: "left" | "center" | "right";
        [fields.title]: string;
        [fields.titleLink]: LinkFieldValue;
        [fields.links]: LinkModel[];
        [fields.customCSS]: string;
        [fields.slides]: SlideModel[];
        [fields.internalListLinks]: InternalListModel;
        [fields.innerSlides]: testModel[];
        [fields.image]: string;
    };
    extendedStyles?: LinkListStyles;
}

export interface LinkListStyles {
    linkListWrapper?: InjectableCss;
    titleWrapper?: InjectableCss;
    title?: TypographyPresentationProps;
    linkWrapper?: InjectableCss;
    textStyle?: InjectableCss;
    linkTextStyle?: InjectableCss;
    internalImageContainer?: InjectableCss;
    innerImageStyles?: InjectableCss;
    mainContainer?: InjectableCss;
    container?: InjectableCss;
    innerContainer?: InjectableCss;
    test1?: InjectableCss;
}

export const linkListStyles: LinkListStyles = {
    linkListWrapper: {
        css: css`
            text-transform: uppercase;
            padding: 10px 0;
        `,
    },
    internalImageContainer: {
        css: css`
            display: flex;
            flex-wrap: wrap;
        `,
    },
    innerImageStyles: {
        css: css`
            display: flex;
            width: 48%;
            max-height: 50%;
            height: 50%;
            > img {
                max-width: 100%;
                max-height: 48%;
                height: auto;
            }
            > span {
                max-width: 100%;
                max-height: 48%;
                height: auto;
                > img {
                    max-width: 100%;
                    max-height: 48%;
                    height: auto;
                }
            }
        `,
    },
    textStyle: {
        css: css`
            color: black;
            background-color: #fafafa;
            padding: 17px 17px 16px 17px;
            box-shadow: 0 0 8px -3px rgba(0, 0, 0, 0.4);
        `,
    },
    linkTextStyle: {
        css: css`
            color: black;
            background-color: #fafafa;
            padding: 17px 17px 16px 17px;
            box-shadow: 0 0 8px -3px rgba(0, 0, 0, 0.4);
            display: flex;
            > span {
                max-height: 100%;
                max-width: 100%;
                height: auto;
            }
        `,
    },
    innerContainer: {
        css: css`
            max-height: 100%;
            max-width: 100%;
            height: auto;
            > img {
                max-height: 100%;
                max-width: 100%;
                height: auto;
            }
        `,
    },
    test1: {
        css: css`
            display: flex;
            margin: auto auto 0 auto;
            height: 50%;
            width: 100vw;
            position: absolute;
            top: 30%;
            background: linear-gradient(to top, #fff, transparent);
        `,
    },
    mainContainer: {
        css: css`
            display: flex;
            max-width: 1360px;
            margin: 0 auto;
            /* margin-top: -40vh !important; */
            margin-top: -17% !important;
            z-index: 9;
            position: relative;
            padding-bottom: 130px;
        `,
    },
    container: {
        css: css`
            width: 25%;
            padding: 0 8px;
        `,
    },
    titleWrapper: {
        css: css`
            font-weight: 700;
            color: #154585;
            font-size: 16px !important;
            line-height: 24px;
            margin-bottom: 9px;
            min-height: 48px;
        `,
    },
};

const defaultCustomCss = `.list-wrapper {
}

.title-wrapper {
}

.list-title {
}

.links-wrapper {
}

.list-link {
}
`;

export const ImageLinkList: FC<OwnProps> = ({ fields, extendedStyles }) => {
    const links = useGetLinks(fields.slides, o => o.fields.destination);
    const titleLink = useGetLink(fields.titleLink);
    const styles = useMergeStyles("linkList", linkListStyles, extendedStyles);
    const Url = links.map((link, index) => link.url);

    // const alignmentStyles = {
    //     css: css`
    //         text-align: ${fields.alignment || "right"};
    //         ${styles.linkListWrapper?.css}
    //     `,
    // };

    const directionStyles = {
        css: css`
            ${fields.direction === "horizontal"
                ? `
                    display: inline-block;
                    padding: 1px 18px 0 0;

                    &:last-child {
                        padding: 1px 0 0 0;
                    }
                `
                : "padding: 1px 0 0 0;"}
            ${styles.linkWrapper?.css}
        `,
    };

    const customCssWrapper = {
        css: css`
            ${fields.customCSS}
            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    css`
                        display: none;
                    `,
                    css`
                        display: none;
                    `,
                    css`
                        display: none;
                    `,
                    css`
                        display: none;
                    `,
                    css`
                        display: block;
                    `,
                ]);
            }}
        `,
    };
    const redirectToTop = () => {
        window.scrollTo(0, 0);
    };

    return (
        <StyledWrapper {...customCssWrapper}>
            <StyledWrapper className="list-wrapper" {...styles.mainContainer}>
                {fields?.slides.map((slide, index) => {
                    return (
                        <StyledWrapper key={index} {...directionStyles} {...styles.container}>
                            {Url[index] === undefined || "" ? (
                                <StyledWrapper>
                                    <StyledWrapper className="no-list-link" {...styles.textStyle}>
                                        <StyledWrapper {...styles.innerContainer}>
                                            <>
                                                <StyledWrapper {...styles.titleWrapper}>
                                                    {slide.fields.Title}
                                                </StyledWrapper>
                                                <Img src={slide.fields.Image} />

                                                {fields.innerSlides?.map((innerSlide, index) => {
                                                    return (
                                                        <StyledWrapper key={index}>
                                                            <Img src={innerSlide.fields.innerImage} />
                                                        </StyledWrapper>
                                                    );
                                                })}

                                                {slide?.fields?.internalListLinks && (
                                                    <StyledWrapper {...styles.internalImageContainer}>
                                                        {slide?.fields?.internalListLinks.map(
                                                            (item: InternalListModel, index) => {
                                                                return (
                                                                    <Link
                                                                        key={index}
                                                                        onClick={redirectToTop}
                                                                        href={item?.fields?.destination?.value}
                                                                        {...styles.innerImageStyles}
                                                                    >
                                                                        <Img src={item.fields.internalImage} />
                                                                    </Link>
                                                                );
                                                            },
                                                        )}
                                                    </StyledWrapper>
                                                )}
                                            </>
                                        </StyledWrapper>
                                    </StyledWrapper>
                                </StyledWrapper>
                            ) : (
                                <Link
                                    className="list-link"
                                    href={Url[index]}
                                    onClick={redirectToTop}
                                    {...styles.linkTextStyle}
                                >
                                    <StyledWrapper {...styles.innerContainer}>
                                        <>
                                            <StyledWrapper {...styles.titleWrapper}>{slide.fields.Title}</StyledWrapper>
                                            <Img src={slide.fields.Image} />

                                            {fields.innerSlides?.map((innerSlide, index) => {
                                                return (
                                                    <StyledWrapper key={index}>
                                                        <Img src={innerSlide.fields.innerImage} />
                                                    </StyledWrapper>
                                                );
                                            })}

                                            {slide?.fields?.internalListLinks && (
                                                <StyledWrapper {...styles.internalImageContainer}>
                                                    {slide?.fields?.internalListLinks.map(
                                                        (item: InternalListModel, index) => {
                                                            return (
                                                                <StyledWrapper key={index} {...styles.innerImageStyles}>
                                                                    <Img src={item.fields.internalImage} />
                                                                </StyledWrapper>
                                                            );
                                                        },
                                                    )}
                                                </StyledWrapper>
                                            )}
                                        </>
                                    </StyledWrapper>
                                </Link>
                            )}
                        </StyledWrapper>
                    );
                })}
            </StyledWrapper>
        </StyledWrapper>
    );
};

const basicTab = {
    displayName: "Basic",
    sortOrder: 0,
};

const advancedTab = {
    displayName: "Advanced",
    sortOrder: 1,
};

const contentTab = {
    displayName: "Content",
    sortOrder: 0,
};

const widgetModule: WidgetModule = {
    component: ImageLinkList,
    definition: {
        group: "Basic",
        icon: "ax-link-list",
        fieldDefinitions: [
            {
                name: fields.slides,
                editorTemplate: "ListField",
                tab: basicTab,
                getDisplay: (item: HasFields, state) => {
                    const {
                        destination: { type, value },
                        Title,
                    } = item.fields;
                    if (Title) {
                        return Title;
                    }
                    if (type === "Page") {
                        const link = getPageLinkByNodeId(state, value);
                        return link?.title;
                    }
                    if (type === "Category") {
                        let displayValue = "";
                        const categories = (state as any).pageEditor.categories;
                        if (!categories) {
                            displayValue = "Loading...";
                        } else {
                            const matchingCategories = categories.filter((o: { id: string }) => o.id === value);
                            if (matchingCategories.length === 0) {
                                displayValue = "Unknown";
                            } else {
                                displayValue = matchingCategories[0].shortDescription;
                            }
                        }

                        return displayValue;
                    }
                    if (type === "Url") {
                        return value;
                    }
                    return value;
                },
                defaultValue: [],
                fieldType: "General",
                fieldDefinitions: [
                    {
                        name: "Title",
                        displayName: "Title",
                        editorTemplate: "TextField",
                        defaultValue: "",
                        sortOrder: 0,
                    },
                    {
                        name: "Image",
                        displayName: "Image",
                        editorTemplate: "ImagePickerField",
                        defaultValue: "",
                        sortOrder: 1,
                    },
                    {
                        name: "destination",
                        editorTemplate: "LinkField",
                        defaultValue: {
                            value: "",
                            type: "Page",
                        },
                        sortOrder: 2,
                    },
                    {
                        name: fields.internalListLinks,
                        editorTemplate: "ListField",
                        getDisplay: (item: HasFields) => {
                            return item.fields.internalImage;
                        },
                        defaultValue: [],
                        fieldDefinitions: [
                            {
                                name: "internalImage",
                                displayName: "internalImage",
                                editorTemplate: "ImagePickerField",
                                defaultValue: "",
                            },
                            {
                                name: "destination",
                                editorTemplate: "LinkField",
                                defaultValue: {
                                    value: "",
                                    type: "Page",
                                },
                                sortOrder: 2,
                            },
                        ],
                    },
                ],
            },
            {
                name: fields.customCSS,
                displayName: "Custom CSS",
                editorTemplate: "CodeField",
                fieldType: "General",
                tab: advancedTab,
                defaultValue: defaultCustomCss,
                isVisible: (item, shouldDisplayAdvancedFeatures) => !!shouldDisplayAdvancedFeatures,
                validate: value => {
                    if (value === undefined || value === null) {
                        return "";
                    }

                    const result = cssLinter.parse(value, { silent: true });
                    if (result?.stylesheet?.parsingErrors) {
                        // the error output at this time only has room for one line so we just show the first error
                        return result.stylesheet.parsingErrors.length <= 0
                            ? ""
                            : result.stylesheet.parsingErrors.map(error => `${error.reason} on line ${error.line}`)[0];
                    }

                    return "Unable to parse Css";
                },
                options: {
                    mode: "css",
                    lint: true,
                    autoRefresh: true,
                },
            },
        ],
    },
};

export default widgetModule;
